import { create } from 'zustand';

import { ICrossSellerBuyerForm } from '../schemas';

export type ICrossSellerStateBuyerForm = ICrossSellerBuyerForm;

interface ICrossSellerStateBuyer {
  buyerForm: ICrossSellerStateBuyerForm;
  setBuyerForm: (CrossSellerState: ICrossSellerStateBuyerForm) => void;
}

export const useBuyerState = create<ICrossSellerStateBuyer>(set => {
  return {
    buyerForm: sessionStorage.getItem('buyerForm')
      ? JSON.parse(sessionStorage.getItem('buyerForm')!)
      : ({ type: 'for_company' } as ICrossSellerStateBuyerForm),
    setBuyerForm(newBuyerForm: ICrossSellerStateBuyerForm) {
      set({ buyerForm: newBuyerForm });
      sessionStorage.setItem('buyerForm', JSON.stringify(newBuyerForm));
    },
  };
});
